import { render } from "./blackList.vue?vue&type=template&id=e30cc816&scoped=true"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"

import "./blackList.vue?vue&type=style&index=0&id=e30cc816&scoped=true&lang=css"
import "./blackList.vue?vue&type=style&index=1&id=e30cc816&lang=css"
script.render = render
script.__scopeId = "data-v-e30cc816"

export default script